export const YellowHeader3 = () => {
  return (
    <section className="yellowHeader">
      <h2>Ważne!</h2>
      <p>
        Jeśli wiesz komu chcesz pomóc, możesz wpisać nazwę tej organizacji w wyszukiwarce. Możesz też filtrować organizacje po ich lokalizacji bądź celu ich
        pomocy.
      </p>
    </section>
  );
};
